import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { updateProfleAction } from "../../../redux/actions/user/userAction";
import { connect } from "react-redux";
import { DialogLeavingPage } from "../../utils/core/blocknavigation/DialogLeavingPage";
import { useNavigatingAway } from "../../utils/core/blocknavigation/useNavigatingAway";

export const JobTitle = (props) => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      top: "5px",
      // Overwrittes the different states of border
      borderColor: state.isFocused ? "#309CCA" : "#309CCA",
    }),
  };

  const dispatch = useDispatch();
  const [inputData, setInputData] = useState([]);
  const [primaryJobTitle, setPrimaryJobTitle] = useState([]);
  const [secondaryJobTitle, setSecondaryJobTitle] = useState([]);
  const [tertiaryJobTitle, setTertiaryJobTitle] = useState([]);
  const [isEnable, setIsEnable] = useState({
    save: false,
  });
  const [canShowDialogLeavingPage, setCanShowDialogLeavingPage] =
    useState(false);
  const [showDialogLeavingPage, confirmNavigation, cancelNavigation] =
    useNavigatingAway(canShowDialogLeavingPage);

  const handleChange = (event, eventName) => {
    setIsEnable((prevState) => ({ ...prevState, save: true }));
    setCanShowDialogLeavingPage(true);
    if (
      eventName === "primary_jobTitle" ||
      eventName === "secondary_jobTitle" ||
      eventName === "tertiary_jobTitle" ||
      eventName === "primary_grade" ||
      eventName === "secondary_grade" ||
      eventName === "tertiary_grade"
    ) {
      if (event != null) {
        setInputData((prevState) => ({
          ...prevState,
          [eventName]: event["id"],
        }));
        if (eventName === "primary_jobTitle") {
          setPrimaryJobTitle(event);
        } else if (eventName === "secondary_jobTitle") {
          setSecondaryJobTitle(event);
        } else if (eventName === "tertiary_jobTitle") {
          setTertiaryJobTitle(event);
        }
      } else {
        setInputData((prevState) => ({ ...prevState, [eventName]: null }));
      }
    } else {
      setInputData((prevState) => ({
        ...prevState,
        [event.target.name]: event.target.value,
      }));
    }
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    const updateJobTitle = {
      userId: inputData.userId,
      primary_jobTitle: inputData.primary_jobTitle,
      primary_grade: inputData.primary_grade,
      primary_jobTitle_experience: inputData.primary_jobTitle_experience,
      secondary_jobTitle: inputData.secondary_jobTitle,
      secondary_grade: inputData.secondary_grade,
      secondary_jobTitle_experience: inputData.secondary_jobTitle_experience,
      tertiary_jobTitle: inputData.tertiary_jobTitle,
      tertiary_grade: inputData.tertiary_grade,
      tertiary_jobTitle_experience: inputData.tertiary_jobTitle_experience,
    };
    dispatch(updateProfleAction(inputData.userId, updateJobTitle));
    setIsEnable((prevState) => ({ ...prevState, save: false }));
    setCanShowDialogLeavingPage(false);
  };

  useEffect(() => {
    if (Object.keys(props.profile).length >= 0) {
      const jobTitle = {
        userId: props.profile.userId,
        primary_jobTitle: props.profile.primary_jobTitle,
        primary_grade: props.profile.primary_grade,
        primary_jobTitle_experience: props.profile.primary_jobTitle_experience,
        secondary_jobTitle: props.profile.secondary_jobTitle,
        secondary_grade: props.profile.secondary_grade,
        secondary_jobTitle_experience:
          props.profile.secondary_jobTitle_experience,
        tertiary_jobTitle: props.profile.tertiary_jobTitle,
        tertiary_grade: props.profile.tertiary_grade,
        tertiary_jobTitle_experience:
          props.profile.tertiary_jobTitle_experience,
      };
      setInputData(jobTitle);
    }

    if (props.jobTitles.length > 0) {
      if (inputData.primary_jobTitle) {
        const primaryJobTitleData = props.jobTitles.find(
          (row) => row.id === inputData.primary_jobTitle
        );
        if (
          primaryJobTitleData.function === props.primaryFunctionId &&
          props.primarySectorId != null
        ) {
          setPrimaryJobTitle(primaryJobTitleData);
        } else {
          setPrimaryJobTitle(null);
        }
      }
      if (inputData.secondary_jobTitle) {
        const secondaryJobTitleData = props.jobTitles.find(
          (row) => row.id === inputData.secondary_jobTitle
        );
        if (
          secondaryJobTitleData.function === props.secondaryFunctionId &&
          props.secondarySectorId != null
        ) {
          setSecondaryJobTitle(secondaryJobTitleData);
        } else {
          setSecondaryJobTitle(null);
        }
      }
      if (inputData.tertiary_jobTitle) {
        const tertiaryJobTitleData = props.jobTitles.find(
          (row) => row.id === inputData.tertiary_jobTitle
        );
        if (
          tertiaryJobTitleData.function === props.tertiaryFunctionId &&
          props.tertiarySectorId != null
        ) {
          setTertiaryJobTitle(tertiaryJobTitleData);
        } else {
          setTertiaryJobTitle(null);
        }
      }
    }
  }, [
    props.profile,
    props.primaryFunctionId,
    props.secondaryFunctionId,
    props.tertiaryFunctionId,
    props.profileData,
    props.primarySectorId,
    props.secondarySectorId,
    props.tertiarySectorId,
  ]);
  return (
    <div className="row margin-row">
      <DialogLeavingPage
        showDialog={showDialogLeavingPage}
        setShowDialog={setCanShowDialogLeavingPage}
        confirmNavigation={confirmNavigation}
        cancelNavigation={cancelNavigation}
        title={"Job Title"}
      />
      <div className="col-12 ">
        <div className="timeline-border-box">
          <h5>Job Title</h5>
          <div className="row">
            <div className="col-md-4 col-12" style={{ paddingTop: "1%" }}>
              <label className="field-label">Primary Job</label>
              <div className="expertise-fields">
                <div className="single-field mb-3">
                  <Select
                    id="primary_jobTitle"
                    name="primary_jobTitle"
                    value={
                      props.jobTitles &&
                      props.jobTitles.find(
                        (row) => row.id === inputData.primary_jobTitle
                      )
                    }
                    options={
                      props.jobTitles &&
                      props.jobTitles.filter((val) =>
                        [props.primaryFunctionId].includes(val["function"])
                      )
                    }
                    getOptionLabel={(option) => option.job_title}
                    getOptionValue={(option) => option.id}
                    onChange={(event) =>
                      handleChange(event, "primary_jobTitle")
                    }
                    placeholder="Choose.."
                    isClearable={true}
                    styles={customStyles}
                    isDisabled={props.primarySectorId === null ? true : false}
                  />
                  {inputData.primary_jobTitle != null &&
                  inputData.primary_jobTitle === true ? (
                    <Link className="edit-btn" to="">
                      <span>
                        <img src="/assets/images/icons/warning.svg" alt="" />
                      </span>
                    </Link>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-4 col-12" style={{ paddingTop: "1%" }}>
              <label className="field-label">Grade</label>
              <div className="expertise-fields">
                <div className="single-field mb-3">
                  <Select
                    id="primary_grade"
                    name="primary_grade"
                    value={
                      props.grade &&
                      props.grade.find(
                        (row) => row.id === inputData.primary_grade
                      )
                    }
                    options={props.grade}
                    getOptionLabel={(option) => option.grade}
                    getOptionValue={(option) => option.id}
                    onChange={(event) => handleChange(event, "primary_grade")}
                    placeholder="Choose.."
                    isClearable={true}
                    styles={customStyles}
                    isDisabled={props.primarySectorId === null ? true : false}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-4 col-12" style={{ paddingTop: "1%" }}>
              <label className="field-label">Years Of Experience</label>
              <div className="expertise-fields">
                <div className="single-field mb-3">
                  <input
                    type="number"
                    className="form-control"
                    name="primary_jobTitle_experience"
                    min="0"
                    placeholder="Primary Job Years Of Experience"
                    defaultValue={props.profile.primary_jobTitle_experience}
                    onChange={(event) => handleChange(event)}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-4 col-12">
              <label className="field-label">Secondary Job </label>
              <div className="expertise-fields">
                <div className="single-field mb-3">
                  <Select
                    id="secondary_jobTitle"
                    name="secondary_jobTitle"
                    value={
                      props.jobTitles &&
                      props.jobTitles.find(
                        (row) => row.id === inputData.secondary_jobTitle
                      )
                    }
                    options={
                      props.jobTitles &&
                      props.jobTitles.filter((val) =>
                        [props.secondaryFunctionId].includes(val["function"])
                      )
                    }
                    getOptionLabel={(option) => option.job_title}
                    getOptionValue={(option) => option.id}
                    onChange={(event) =>
                      handleChange(event, "secondary_jobTitle")
                    }
                    placeholder="Choose.."
                    isClearable={true}
                    styles={customStyles}
                  />
                  {inputData.secondary_jobTitle != null &&
                  inputData.secondary_jobTitle === true ? (
                    <Link className="edit-btn" to="">
                      <span>
                        <img src="/assets/images/icons/warning.svg" alt="" />
                      </span>
                    </Link>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-4 col-12">
              <label className="field-label">Grade</label>
              <div className="expertise-fields">
                <div className="single-field mb-3">
                  <Select
                    id="secondary_grade"
                    name="secondary_grade"
                    value={
                      props.grade &&
                      props.grade.find(
                        (row) => row.id === inputData.secondary_grade
                      )
                    }
                    options={props.grade}
                    getOptionLabel={(option) => option.grade}
                    getOptionValue={(option) => option.id}
                    onChange={(event) => handleChange(event, "secondary_grade")}
                    placeholder="Choose.."
                    isClearable={true}
                    styles={customStyles}
                    isDisabled={props.primarySectorId === null ? true : false}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-4 col-12">
              <label className="field-label">Years Of Experience</label>
              <div className="expertise-fields">
                <div className="single-field mb-3">
                  <input
                    type="number"
                    className="form-control"
                    min="0"
                    name="secondary_jobTitle_experience"
                    placeholder="Secondary Job Years Of Experience"
                    defaultValue={props.profile.secondary_jobTitle_experience}
                    onChange={(event) => handleChange(event)}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-4 col-12">
              <label className="field-label">Tertiary Job </label>
              <div className="expertise-fields">
                <div className="single-field mb-3">
                  <Select
                    id="tertiary_jobTitle"
                    name="tertiary_jobTitle"
                    value={
                      props.jobTitles &&
                      props.jobTitles.find(
                        (row) => row.id === inputData.tertiary_jobTitle
                      )
                    }
                    options={props.jobTitles}
                    getOptionLabel={(option) => option.job_title}
                    getOptionValue={(option) => option.id}
                    onChange={(event) =>
                      handleChange(event, "tertiary_jobTitle")
                    }
                    placeholder="Choose.."
                    isClearable={true}
                    styles={customStyles}
                  />
                  {inputData.tertiary_jobTitle != null &&
                  inputData.tertiary_jobTitle === true ? (
                    <Link className="edit-btn" to="">
                      <span>
                        <img src="/assets/images/icons/warning.svg" alt="" />
                      </span>
                    </Link>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-4 col-12">
              <label className="field-label">Grade</label>
              <div className="expertise-fields">
                <div className="single-field mb-3">
                  <Select
                    id="tertiary_grade"
                    name="tertiary_grade"
                    value={
                      props.grade &&
                      props.grade.find(
                        (row) => row.id === inputData.tertiary_grade
                      )
                    }
                    options={props.grade}
                    getOptionLabel={(option) => option.grade}
                    getOptionValue={(option) => option.id}
                    onChange={(event) => handleChange(event, "tertiary_grade")}
                    placeholder="Choose.."
                    isClearable={true}
                    styles={customStyles}
                    isDisabled={props.primarySectorId === null ? true : false}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-4 col-12">
              <label className="field-label">Years Of Experience</label>
              <div className="expertise-fields">
                <div className="single-field mb-3">
                  <input
                    type="number"
                    className="form-control"
                    min="0"
                    name="tertiary_jobTitle_experience"
                    placeholder="Tertiary Job Years Of Experience"
                    defaultValue={props.profile.tertiary_jobTitle_experience}
                    onChange={(event) => handleChange(event)}
                  />
                </div>
              </div>
            </div>
          </div>{" "}
          <div className="col text-right ">
            {isEnable.save ? (
              <Link className="edit-btn" to="" onClick={handleFormSubmit}>
                
                <span>
                  <img src="/assets/images/icons/save.png" alt="" />Save
                </span>
              </Link>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const user = state.user.user;
  const profile = state.user.profile;
  const jobTitles = state.admin.jobTitles;
  const grade = state.admin.grade;

  return {
    user: user,
    profile: profile,
    jobTitles: jobTitles,
    grade: grade,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(JobTitle);
